export const appCdnURL = "https://static.apostatudo.bet.br/deploy-bfe00002e434ced5b0a28a0948f54ffb2bf9b482-7bf3f78cf2b359077c48"

export const appHead = {"link":[{"rel":"dns-prefetch","crossorigin":"","href":"https://static.apostatudo.bet.br"},{"rel":"dns-prefetch","crossorigin":"","href":"https://imagedelivery.net"},{"rel":"preconnect","crossorigin":"","href":"https://static.apostatudo.bet.br"},{"rel":"preconnect","crossorigin":"","href":"https://imagedelivery.net"},{"rel":"icon","type":"image/png","href":"https://static.apostatudo.bet.br/deploy-bfe00002e434ced5b0a28a0948f54ffb2bf9b482-7bf3f78cf2b359077c48/assets/favicon.png?v=deploy-bfe00002e434ced5b0a28a0948f54ffb2bf9b482-7bf3f78cf2b359077c48-1785945712347"},{"rel":"manifest","href":"https://apostatudo.bet.br/manifest.webmanifest?v=deploy-bfe00002e434ced5b0a28a0948f54ffb2bf9b482-7bf3f78cf2b359077c48-1785945712347"},{"rel":"apple-touch-icon","href":"https://static.apostatudo.bet.br/public-assets/pwa-512x512.png?v=deploy-bfe00002e434ced5b0a28a0948f54ffb2bf9b482-7bf3f78cf2b359077c48-1785945712347","sizes":"512x512"},{"rel":"mask-icon","href":"https://static.apostatudo.bet.br/public-assets/maskable-icon-512x512.png?v=deploy-bfe00002e434ced5b0a28a0948f54ffb2bf9b482-7bf3f78cf2b359077c48-1785945712347","color":"#323637"},{"rel":"preconnect","href":"https://static.apostatudo.bet","crossorigin":"anonymous"},{"rel":"dns-prefetch","href":"https://static.apostatudo.bet"},{"rel":"preconnect","href":"https://imagedelivery.net","crossorigin":"anonymous"},{"rel":"dns-prefetch","href":"https://imagedelivery.net"},{"rel":"preconnect","href":"https://apiapostatudo.com","crossorigin":"anonymous"},{"rel":"dns-prefetch","href":"https://apiapostatudo.com"}],"meta":[{"charset":"utf-8"},{"name":"mobile-web-app-capable","content":"yes"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=1, viewport-fit=cover, user-scalable=no, shrink-to-fit=no"},{"name":"facebook-domain-verification","content":"7dmvyzbcto0tzohhsk6a171553l7uk"},{"name":"theme-color","content":"#323637"},{"name":"apple-mobile-web-app-title","content":"ApostaTudo"},{"name":"description","content":"ApostaTudo - apostas esportivas e jogos online autorizados. Plataforma segura com saque rápido. 18+ | Jogue com responsabilidade."},{"name":"og:title","content":"Aposta Tudo Bet"},{"name":"og:site_name","content":"ApostaTudo"},{"name":"og:type","content":"website"},{"name":"og:description","content":"ApostaTudo - apostas esportivas e jogos online autorizados. Plataforma segura com saque rápido. 18+ | Jogue com responsabilidade."},{"name":"x-build-id","content":"deploy-bfe00002e434ced5b0a28a0948f54ffb2bf9b482-7bf3f78cf2b359077c48-1785945712345"},{"name":"build-version","content":"multi-app"},{"property":"og:type","content":"website"}],"style":[],"script":[],"noscript":[],"htmlAttrs":{"class":"html-app-apostatudo","lang":"pt-br"},"title":"Aposta Tudo Bet"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = false

export const componentIslands = false

export const payloadExtraction = false

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"deep":false}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = true

export const spaLoadingTemplateOutside = true

export const purgeCachedData = true

export const granularCachedData = true

export const pendingWhenIdle = false

export const alwaysRunFetchOnKeyChange = false